import React, { useRef, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid";
import SelectComponent from "../../components/SelectComponent/SelectComponent";
import Addguest from "./Addguest";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import lang from "../../assets/lang.png";
import DateComponent from "./DateComponent";
import ReservationType from "./ReservationType";
import TimeComponent from "./TimeComponent";
import {
  setGuestCount,
  updateSelectedDate,
  updateTime,
  updateActivityDuration,
  updateReservationType,
  updateDefaultLanguage,
} from "../../store/slice/Activity.slice";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import calenderImg from "../../assets/CalendarAct.png";
import { checkGuestLimit } from "../../store/slice/Activity.slice";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "@emotion/react";
import { formatName, formatTimeString, format_Number, translateTimeValue } from "../../utils/utils";
dayjs?.extend(customParseFormat); // Extend for custom date format parsing

let loadSettings = null;
let widgetIdSettings = null;

const WidgetComponent = ({ handleClose }) => {
  const isSmallScreen = useMediaQuery("sm");
  const isMediumScreen = useMediaQuery("md");
  const {
    languageData,
    widgetConfig,
    widgetPosition,
    key,
    widgetSetupId,
    resType,
    floating,
  } = useSelector((store) => store?.widgetSettings);
  const location = useLocation();
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [reservTypeLoading, setReserveTypeLoading] = useState(false);
  const [isAddGuest, setIsAddGuest] = useState(false);
  const guestRef = useRef(null);
  const dateRef = useRef(null);

  const reservationType = useRef(null);
  const timeRef = useRef(null);
  const activityDurationRef = useRef(null);
  const [isDateDropdownOpen, setIsDateDropdownOpen] = useState(false);
  const [isReservationType, setIsReservationType] = useState(false);
  const [isTimeComponent, setIsTimeComponent] = useState(false);
  const [isActivityDuration, setIsActivityDuration] = useState(false);
  const {
    totalCount,
    selectedDate,
    reservType,
    time,
    adult,
    defaultLanguage,
    isGreaterThan10,
    languageWords,
    activityDuration,
  } = useSelector((store) => store.Activity);

  const getWidgetPositionStyle = (position, btn) => {
    switch (position) {
      case "Top-Left":
        return { top: "0", left: "0", transform: "translate(0, 0)" };
      case "Top-Middle":
        return { top: "0", left: "50%", transform: "translateX(-50%)" };
      case "Top-Right":
        return { top: "0", right: "0", transform: "translate(0, 0)" };
      case "Middle-Left":
        return { top: "50%", left: "0", transform: "translateY(-50%)" };
      case "Middle-Center":
        return { top: "50%", left: "50%", transform: "translate(-50%, -50%)" };
      case "Middle-Right":
        return { top: "50%", right: "0", transform: "translateY(-50%)" };
      case "Bottom-Left":
        return { bottom: "0", left: "0", transform: "translate(0, 0)" };
      case "Bottom-Middle":
        return { bottom: "0", left: "50%", transform: "translateX(-50%)" };
      case "Bottom-Right":
        return { bottom: "0", right: "0", transform: "translate(0, 0)" };
      default:
        // Center by default if position not recognized
        if (btn) {
          return { bottom: "0", right: "0", transform: "translate(0, 0)" };
        } else {
          return {
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          };
        }
    }
  };
  const handleLanguageChange = (event) => {
    const selectedLangCode = event.target.value;
    const selectedLanguage = languageData.find(
      (item) => item.langcode === selectedLangCode
    );
    dispatch(updateDefaultLanguage(selectedLanguage?.langcode));
    localStorage.setItem(
      "widget",
      JSON.stringify({
        id: widgetSetupId,
        key: key,
        lang: selectedLanguage?.langcode,
        resType: resType,
      })
    );
  };

  const nonEmptyFields = Object.keys({})
    .filter(
      (key) =>
        key.startsWith("field") && widgetConfig?.fields[key].trim() !== ""
    )
    .map((key) => widgetConfig?.fields[key]);

  return (
    <Box
      className="test"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: isSmallScreen ? "flex-start" : "flex-end",
        position: "absolute",
        width: "100%",
        top: 0,
        // bottom: "0px",
        paddingBottom: "20px",
        backgroundColor: theme.widget?.mainBg,

        height: isSmallScreen || isMediumScreen ? "100%" : "auto",
        zIndex: 1000,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "1567px",
          padding: { xs: 2, sm: 3 },
          height: "100%",
        }}
      >
        <Grid
          item
          xs={12}
          spacing={2}
          sx={{ mb: 2 }}
          display={'flex'}
          justifyContent={"space-between"}
          alignItems={"center"}
       
        >
          <Box>
            <Typography sx={{ fontWeight: "bold", fontSize: "1.2rem" }}>
              {languageWords?.CreateActivities || "Make your Reservations"}
            </Typography>
          </Box>
          {languageData?.length > 1 && (
            <Box sx={{ display: "flex", gap: "1rem", alignItems: "center" }}>
              <FormControl
                variant="outlined"
                sx={{
                  minWidth: 120,
                  backgroundColor: theme?.widget?.langBgColor,
                  width: { xs: "100px", md: "120px" },
                  height: "45px",
                  borderRadius: "5px",
                }}
              >
                <Select
                  value={defaultLanguage}
                  onChange={handleLanguageChange} // Set the onChange handler here
                  // IconComponent={() => (
                  //     <KeyboardArrowDownIcon
                  //         sx={{ color: "black", mr: 1 }}
                  //     />
                  // )}
                  displayEmpty
                  renderValue={() => (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={lang}
                        alt={"lang-img"}
                        style={{ width: "40px", marginRight: "10px" }}
                      />
                    </Box>
                  )}
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "transparent",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "transparent",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "transparent",
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: 1,
                      //     color: "#9F9F9F",
                      fontSize: "12px",
                    },
                  }}
                >
                  {languageData?.map((item, index) => (
                    <MenuItem
                      key={item?.idlanguage}
                      value={item?.langcode}
                      sx={{
                        color: theme?.palette?.widget?.langTextColor, // Text color of MenuItem
                        "&.Mui-selected": {
                          backgroundColor: theme?.widget?.langActiveBgColor, // Highlight selected item
                        },
                        "&:hover": {
                          backgroundColor: theme?.widget?.langBgHover, // Hover effect for MenuItem
                          color: theme?.widget?.langTextHover,
                          "&.Mui-selected": {
                            backgroundColor: theme?.widget?.langBgHover, // Hover effect for MenuItem
                            color: theme?.widget?.langTextHover,
                          },
                        },
                      }}
                    >
                      {(item?.langcode == defaultLanguage?.trim()) != "" ? (
                        <>
                          {item?.language}
                          <CheckBoxIcon
                            sx={{
                              color: theme?.widget?.langCheckboxActive,
                              marginRight: "8px",
                              ml: 2,
                            }}
                          />
                        </>
                      ) : (
                        item?.language
                      )}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {floating != "relative" && (
                <IconButton
                  aria-label="closeIcon"
                  size="large"
                  onClick={() => handleClose()}
                  sx={{
                    backgroundColor: theme?.widgetButton?.closeBg,

                    "&:hover": {
                      backgroundColor: theme?.widgetButton?.closeHover,
                    },
                  }}
                >
                  <CloseIcon
                    sx={{
                      color: theme?.widgetButton?.closeText,
                      "&:hover": {
                        color: theme?.widgetButton?.textcloseTextHover,
                      },
                    }}
                  />
                </IconButton>
              )}
            </Box>
          )}
        </Grid>

        <Grid
          container
          spacing={2}
          sx={{ mb: 3 }}
          justifyContent={"center"}
          alignItems={"center"}
          
        >
      
          {!nonEmptyFields ||
          nonEmptyFields.length == 1 ||
          nonEmptyFields.length == 0 ? (
            <Grid item xs={12} sm={6} md={4} lg={2}>
              <FormControl
                fullWidth
                sx={{
                  width: "100%",
                  height: "70px",
                  px: 1,
                  position: "relative",
                  backgroundColor: theme?.guest?.bgColor,
                  // Remove border from the outlined input
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },

                  // Ensure the input itself doesn't have a border
                  "& .MuiInputBase-root": {
                    border: "none",
                    boxShadow: "none",
                  },

                  // Remove border on focus
                  "& .Mui-focused": {
                    border: "none",
                    boxShadow: "none",
                  },
                }}
              >
                {isGreaterThan10?.adult ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: { xs: "0.1rem", sm: "0.2rem" },
                    }}
                  >
                    <IconButton
                      aria-label="add-icon"
                      sx={{
                        color: theme?.guest?.textColor,
                        position: "absolute",
                        left: "3rem",
                        top: "50%",
                        transform: "translateY(-50%)",
                        zIndex: 2,
                      }}
                      onClick={(event) => {
                        event.stopPropagation(); // Prevent TextField click
                        if (adult > 1) {
                          //   resetReservationData();
                          dispatch(updateSelectedDate(""));
                          dispatch(updateReservationType({}));
                          dispatch(updateTime(""));
                          dispatch(updateActivityDuration(""));
                          dispatch(
                            setGuestCount({
                              guestType: "adult",
                              count: adult - 1,
                            })
                          );
                        }
                      }}
                    >
                      <RemoveCircleIcon />
                    </IconButton>
                    <Typography
                      sx={{
                        position: "absolute",
                        top: 10,
                        left: 20,
                        fontSize: "12px",
                        color: theme?.widget?.inputTextColor,
                        fontWeight: 200,
                      }}
                    >
                      {languageWords?.Guest}
                    </Typography>
                    <TextField
                      sx={{
                        position: "relative",
                        height: "30px",
                        width: "100%",
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: theme?.guest?.dropdownBorderColor,
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: theme?.guest?.dropdownBorderColor,
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          padding: 1,
                          textAlign: "center",
                          py: 3,
                          color: "#9F9F9F",
                        },
                      }}
                      placeholder="00"
                      name="adult"
                      value={adult}
                      disabled={true}
                    />
                    <IconButton
                      aria-label="add-icon"
                      sx={{
                        color: theme?.guest?.textColor,
                        position: "absolute",
                        right: "3rem",
                        top: "50%",
                        transform: "translateY(-50%)",
                        zIndex: 2,
                      }}
                      onClick={() => {
                        //  resetReservationData();
                        dispatch(updateSelectedDate(""));
                        dispatch(updateReservationType({}));
                        dispatch(updateTime(""));
                        dispatch(updateActivityDuration(""));
                        dispatch(
                          setGuestCount({
                            guestType: "adult",
                            count: adult + 1,
                          })
                        );
                      }}
                    >
                      <AddCircleIcon />
                    </IconButton>
                  </Box>
                ) : (
                  <Box>
                    <Typography
                      sx={{
                        position: "absolute",
                        top: 10,
                        left: 20,
                        fontSize: "12px",
                        color: theme?.widget?.inputTextColor,
                        fontWeight: 200,
                      }}
                    >
                      {languageWords?.Guest}
                    </Typography>
                    <KeyboardArrowDownIcon
                      sx={{
                        position: "absolute",
                        top: 20,
                        right: 20,
                      }}
                    />

                    <Select
                      id="demo-simple-select"
                      value={adult}
                      fullWidth
                      // IconComponent={KeyboardArrowDownIcon}
                      IconComponent={null} // Remove the default arrow icon
                      sx={{
                        position: "relative",

                        width: "100%",
                        height: "72px",
                        "& .MuiOutlinedInput-input": {
                          padding: 1,
                          color: theme?.guest?.textColor,
                          ml: 3,
                          mt: 1,
                          fontSize: { sm: "12px", md: "14px" },
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none !important", // Remove default border
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          border: "none !important", // Ensure no border on hover
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: "none", // Ensure no border on focus
                        },
                      }}
                      onChange={(event) => {
                        //  resetReservationData();
                        dispatch(updateSelectedDate(""));
                        dispatch(updateReservationType({}));
                        dispatch(updateTime(""));
                        dispatch(updateActivityDuration(""));
                        dispatch(
                          setGuestCount({
                            guestType: "adult",
                            count: Number(event.target.value),
                          })
                        );
                      }}
                    >
                      {new Array(10).fill(null).map((_, index) => (
                        <MenuItem
                          key={index}
                          value={index + 1}
                          sx={{
                            color: theme?.guest?.dropdownTextColor,
                            width: "100%",
                            fontSize: { sm: "12px", md: "1.2rem" },
                            "&:hover": {
                              backgroundColor: theme?.guest?.dropdownBgHover,
                              color: theme?.guest?.dropdownTextColorHover,
                            },
                          }}
                        >
                          {index + 1}
                        </MenuItem>
                      ))}
                      <MenuItem
                        value={11}
                        sx={{
                          color: theme?.guest?.dropdownTextColor,
                          fontSize: { sm: "12px" },
                        }}
                        onClick={(event) => {
                          event.stopPropagation();
                          dispatch(updateSelectedDate(""));
                          dispatch(updateReservationType({}));
                          dispatch(updateTime(""));
                          dispatch(updateActivityDuration(""));
                          dispatch(
                            checkGuestLimit({
                              guestType: "adult",
                              isGreaterThan10: true,
                            })
                          );
                          dispatch(
                            setGuestCount({
                              guestType: "adult",
                              count: 11,
                            })
                          );
                        }}
                      >
                        <AddBoxTwoToneIcon
                          sx={{
                            color: theme?.guest?.plusColor,
                            width: { xs: 16, sm: 20 },
                            height: { xs: 16, sm: 20 },
                            "&:hover": {
                              color: theme?.guest?.plusHover,
                            },
                          }}
                        />
                      </MenuItem>
                    </Select>
                  </Box>
                )}
              </FormControl>
            </Grid>
          ) : (
            <Grid item xs={12} sm={6} md={4} lg={2}>
              <SelectComponent
                label={languageWords?.Guest}
                value={totalCount}
                onClick={() => {
                  setIsAddGuest(!isAddGuest);
                }}
                ref={guestRef}
              />
              <Addguest
                isOpen={isAddGuest}
                handleClose={() => setIsAddGuest(false)}
                Ref={guestRef.current}
              />
            </Grid>
          )}
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <SelectComponent
              label={languageWords?.date}
              value={selectedDate?.trim() != "" ? selectedDate : "DD-MM-YYYY"}
              sx={{
                position: "relative",

                width: "100%",
                height: "72px",
                "& .MuiOutlinedInput-notchedOutline": {
                  border: `1px solid ${theme?.widget?.inputBorderColor}`,
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  border: `1px solid ${theme?.widget?.inputBorderColor}`,
                },
                "& .MuiOutlinedInput-input": {
                  padding: 1,
                  color: theme?.guest?.textColor,
                  ml: 3,
                  mt: 1,
                  fontSize: { sm: "12px", md: "14px" },
                },
              }}
              onClick={() => setIsDateDropdownOpen(!isDateDropdownOpen)}
              ref={dateRef}
              icon={calenderImg}
              isIcon={true}
              disabled={totalCount > 0 ? false : true}
            />
            <DateComponent
              isOpen={isDateDropdownOpen}
              handleClose={() => setIsDateDropdownOpen(false)}
              Ref={dateRef.current}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={2}>
            <SelectComponent
              label={languageWords?.reserveType}
              value={
                reservType &&
                typeof reservType === "object" &&
                Object.keys(reservType).length > 0
                  ? reservType?.name
                  : "Type"
              }
              onClick={() => setIsReservationType(!isReservationType)}
              ref={reservationType}
              disabled={!selectedDate}
              sx={{
                position: "relative",

                width: "100%",
                height: "72px",
                "& .MuiOutlinedInput-notchedOutline": {
                  border: `1px solid ${theme?.widget?.inputBorderColor}`,
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  border: `1px solid ${theme?.widget?.inputBorderColor}`,
                },
                "& .MuiOutlinedInput-input": {
                  padding: 1,
                  color: theme?.guest?.textColor,
                  ml: 3,
                  mt: 1,
                  fontSize: { sm: "12px", md: "14px" },
                },
              }}
            />
            <ReservationType
              isOpen={isReservationType}
              handleClose={() => setIsReservationType(false)}
              Ref={reservationType.current}
              isLoading={reservTypeLoading}
            />
          </Grid>
          {reservType?.isPriceBasedOnDuration && (
            <Grid item xs={12} sm={6} md={4} lg={2}>
              <SelectComponent
                label={languageWords?.duration || "Duration"}
                value={
                  activityDuration
                    ? `${formatTimeString(activityDuration?.timeText, languageWords)}  -  € ${format_Number(activityDuration?.price)}`
                    : "HH:MM"
                }
                onClick={() => setIsActivityDuration(!isActivityDuration)}
                ref={activityDurationRef}
                disabled={
                  !selectedDate ||
                  !(
                    reservType &&
                    typeof reservType === "object" &&
                    Object.keys(reservType).length > 0
                  )
                }
                sx={{
                  position: "relative",

                  width: "100%",
                  height: "72px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: `1px solid ${theme?.widget?.inputBorderColor}`,
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: `1px solid ${theme?.widget?.inputBorderColor}`,
                  },
                  "& .MuiOutlinedInput-input": {
                    padding: 1,
                    color: theme?.guest?.textColor,
                    ml: 3,
                    mt: 1,
                    fontSize: { sm: "12px", md: "14px" },
                  },
                }}
              />
              <TimeComponent
                isOpen={isActivityDuration}
                handleClose={() => setIsActivityDuration(false)}
                Ref={activityDurationRef.current}
                isDuration={true}
              />
            </Grid>
          )}

          <Grid item xs={12} sm={6} md={4} lg={2}>
            <SelectComponent
              label={languageWords?.Time}
              value={time?.trim() != "" ? time?.substring(0, 5) : "HH:MM"}
              onClick={() => setIsTimeComponent(!isTimeComponent)}
              ref={timeRef}
              disabled={
                !(
                  reservType &&
                  typeof reservType === "object" &&
                  Object.keys(reservType).length > 0
                ) ||
                (!activityDuration && reservType?.isPriceBasedOnDuration)
              }
              sx={{
                position: "relative",

                width: "100%",
                height: "72px",
                "& .MuiOutlinedInput-notchedOutline": {
                  border: `1px solid ${theme?.widget?.inputBorderColor}`,
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  border: `1px solid ${theme?.widget?.inputBorderColor}`,
                },
                "& .MuiOutlinedInput-input": {
                  padding: 1,
                  color: theme?.guest?.textColor,
                  ml: 3,
                  mt: 1,
                  fontSize: { sm: "12px", md: "14px" },
                },
              }}
            />
            <TimeComponent
              isOpen={isTimeComponent}
              handleClose={() => setIsTimeComponent(false)}
              Ref={timeRef.current}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <Button
              variant="contained"
              fullWidth
              sx={{
                height: "70px",
                backgroundColor:
                  reservType &&
                  typeof reservType === "object" &&
                  Object.keys(reservType).length > 0 &&
                  totalCount > 0 &&
                  selectedDate?.trim() != "" &&
                  time?.trim() != ""
                    ? theme?.widget?.bookNowbtnBgActive
                    : theme?.widget?.bookNowBtnBg,
                color:
                  reservType &&
                  typeof reservType === "object" &&
                  Object.keys(reservType).length > 0 &&
                  totalCount > 0 &&
                  selectedDate?.trim() != "" &&
                  time?.trim() != ""
                    ? theme?.widget?.booknowBtnTextColorActive
                    : theme?.widget?.booknowBtnTextColor,
                fontWeight: "bold",
                display: "flex", // Ensure flexbox is used
                flexDirection: "column", // Align content in a column (Book Now on top, €25,00 below)
                justifyContent: "center", // Center the text vertically
                alignItems: "center", // Center the text horizontally
              }}
              onClick={() => {
                if (
                  reservType &&
                  typeof reservType === "object" &&
                  Object.keys(reservType).length > 0 &&
                  totalCount > 0 &&
                  // selectedDate &&
                  time
                ) {
                  navigate(`/bookNowActivity`);
                } else {
                  return;
                }
              }}
            >
              {languageWords?.Booknow}
              {reservType?.products?.price > 0 && (
                <Box component="span" fontSize="13px" fontWeight="200">
                  €{reservType?.products?.price}
                </Box>
              )}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default WidgetComponent;
